import { __exports as N } from "./index.es74.js";
var c;
function s() {
  if (c) return N;
  c = 1, N.removeSubsets = function(r) {
    for (var i = r.length, n, t, e; --i > -1; ) {
      for (n = t = r[i], r[i] = null, e = !0; t; ) {
        if (r.indexOf(t) > -1) {
          e = !1, r.splice(i, 1);
          break;
        }
        t = t.parent;
      }
      e && (r[i] = n);
    }
    return r;
  };
  var u = {
    DISCONNECTED: 1,
    PRECEDING: 2,
    FOLLOWING: 4,
    CONTAINS: 8,
    CONTAINED_BY: 16
  }, p = N.compareDocumentPosition = function(r, i) {
    var n = [], t = [], e, l, f, O, I, a;
    if (r === i)
      return 0;
    for (e = r; e; )
      n.unshift(e), e = e.parent;
    for (e = i; e; )
      t.unshift(e), e = e.parent;
    for (a = 0; n[a] === t[a]; )
      a++;
    return a === 0 ? u.DISCONNECTED : (l = n[a - 1], f = l.children, O = n[a], I = t[a], f.indexOf(O) > f.indexOf(I) ? l === i ? u.FOLLOWING | u.CONTAINED_BY : u.FOLLOWING : l === r ? u.PRECEDING | u.CONTAINS : u.PRECEDING);
  };
  return N.uniqueSort = function(r) {
    var i = r.length, n, t;
    for (r = r.slice(); --i > -1; )
      n = r[i], t = r.indexOf(n), t > -1 && t < i && r.splice(i, 1);
    return r.sort(function(e, l) {
      var f = p(e, l);
      return f & u.PRECEDING ? -1 : f & u.FOLLOWING ? 1 : 0;
    }), r;
  }, N;
}
export {
  s as __require
};
//# sourceMappingURL=index.es55.js.map
